// Configuration centralisée des URLs de l'API
import { getEnvVar } from './environment-unified';

// Configuration des endpoints
export const API_ENDPOINTS = {
    // Auth endpoints
    AUTH_ME: getEnvVar('AUTH_ENDPOINT') + '/me',
    LOGIN: getEnvVar('LOGIN_ENDPOINT'),
    REGISTER: getEnvVar('SIGNUP_ENDPOINT'),
    RESET_PASSWORD: getEnvVar('AUTH_RESET_PASSWORD_ENDPOINT'),
    NEW_PASSWORD: getEnvVar('AUTH_NEW_PASSWORD_ENDPOINT'),
    DATA_ENDPOINT: getEnvVar('DATA_ENDPOINT'),
    INIT_CHANNEL: getEnvVar('INIT_CHANNEL_ENDPOINT'),

    // OAuth endpoints
    GOOGLE_OAUTH: getEnvVar('OUATH_GOOGLE_ENDPOINT'),
    FACEBOOK_OAUTH: getEnvVar('OUATH_FACEBOOK_ENDPOINT'),

    // Games endpoints
    GAMES: getEnvVar('GAMES_ENDPOINT'),

    // Stream endpoints
    START_STREAM: getEnvVar('START_STREAM_ENDPOINT'),
    STREAMS: getEnvVar('STREAMS_ENDPOINT'),
    STREAM: getEnvVar('STREAM_ENDPOINT'),
    MY_STREAM_KEY: getEnvVar('MYSTREAMKEY_ENDPOINT'),
    CHANNELS_SETTINGS: getEnvVar('CHANNELS_SETTINGS'),
    CHANNELS_SETTINGS_UPDATE: getEnvVar('CHANNELS_SETTINGS_UPDATE'),
    UPDATE_USERNAME: getEnvVar('CHANNELS_SETTINGS_UPDATE_USERNAME'),
    UPDATE_FULLNAME: getEnvVar('CHANNELS_SETTINGS_UPDATE_FULLNAME'),
    UPDATE_PASSWORD: getEnvVar('CHANNELS_SETTINGS_UPDATE_PASSWORD'),
    AVATAR: getEnvVar('AVATAR_ENDPOINT'),
    BANNER: getEnvVar('BANNER_ENDPOINT'),
    SEARCH: getEnvVar('SEARCH_ENDPOINT'),
    SEARCH_GAME: getEnvVar('SEARCH_GAME_ENDPOINT'),
    STREAM_VIEWERS: getEnvVar('STREAM_VIEWERS_ENDPOINT'),
    FOLLOW: getEnvVar('FOLLOW_ENDPOINT'),
    UNFOLLOW: getEnvVar('UNFOLLOW_ENDPOINT'),
    FOLLOWERS: getEnvVar('FOLLOWERS_ENDPOINT'),

    // Tournament endpoints
    TOURNAMENT: getEnvVar('TOURNAMENT_ENDPOINT'),
    CREATE_TOURNAMENT: getEnvVar('CREATE_TOURNAMENT_ENDPOINT'),
    JOIN_TOURNAMENT: getEnvVar('JOIN_TOURNAMENT_ENDPOINT'),
    LEAVE_TOURNAMENT: getEnvVar('LEAVE_TOURNAMENT_ENDPOINT'),
    MY_TOURNAMENTS: getEnvVar('TOURNAMENT_MY_TOURNAMENTS_ENDPOINT'),
    GET_TOURNAMENTS: getEnvVar('TOURNAMENT_GET_TOURNAMENTS_ENDPOINT'),

    // Chat endpoint
    CHAT: getEnvVar('CHAT_ENDPOINT'),
};

// Configuration reCAPTCHA
export const RECAPTCHA_CONFIG = {
    SITE_KEY: getEnvVar('REACPTCHA_SITEKEY'),
    ENABLED: getEnvVar('ENABLE_RECAPTCHA'),
};

export default API_ENDPOINTS; 